import { Alert, Col, Row } from "antd";
import * as React from "react";
import { Tabs } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import Completed from "./completed";
import KitchenCard from "./kitchenCard";
import Topbar from "./topbar";
import config from "../../../config";
import { useSelector } from "react-redux";
import SideMenu from "../../dashboard/sideMenu";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import KotSubscription from "./kot-subscription";
import CustomTabs from "../../tabs";
import Loader from "../../loader";
import { useAccess } from "../../../provider/AccessProvider";

const useStyles = makeStyles((theme) => ({
  root: {
    "& p": {
      margin: "0",
    },
    "& h4": {
      margin: "0",
    },
  },
  tabs: {
    "& .ant-tabs-nav": {
      background: "#FDFBE8",
      "& .ant-tabs-tab-active": {
        background: "#fff",
      },
    },
    "& .ant-tabs-tab": {
      margin: "0",
      paddingLeft: "2rem",
      paddingRight: "2rem",
    },
  },
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
  },
  contentListStyle: {
    "&::-webkit-scrollbar": {
      width: "2px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "body::-webkit-scrollbar-thumb": {
      borderRadius: "20px",
    },
  },
  customCol6: {
    display: "flex",
    justifyContent: "center",
  },
}));

const KitchenOrderView = () => {
  const [tabKey, setTabKey] = React.useState("1");
  const classes = useStyles();
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const [orders, setOrders] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const access = useAccess(["activeOrder", "completedOrder"]);

  console.log("orders1", orders);
  const handleTabs = (key) => {
    setTabKey(key);
  };
  const fetchOrders = async (shopId) => {
    return await Promise.all([
      fetch(`${config.newApiGateway}/kot/manageKot`, {
        method: "POST",
        body: JSON.stringify({ shopId: shopId, action: "fetchKot" }),
        headers: {
          "x-api-key": `${config.newApiKey}`,

          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        setLoading(false);
        setOrders(data.data);
      })
      .catch((err) => {
        setLoading(false);
        console.log("err".err);
      });
  };
  const activeOrders = React.useMemo(() => {
    let result = [];
    result = orders.filter((order) => order.status !== "done");
    return result;
  }, [orders]);
  React.useEffect(() => {
    if (shopId) {
      fetchOrders(shopId);
    }
  }, [shopId]);
  const tabs = [
    {
      key: "1",
      label: "Active",
    },
    {
      key: "2",
      label: "Completed",
    },
  ];
  return (
    <div>
      <div>
        {loading && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <Loader size={56} />
          </Box>
        )}
        {!loading && (
          <>
            <CustomTabs
              items={tabs}
              activeKey={tabKey}
              onTabChange={handleTabs}
              style={{
                marginBottom: 20,
              }}
            />

            {tabKey === "1" && (
              <>
                {access.activeOrder(false) ? (
                  <>
                    {activeOrders.length > 0 ? (
                      <Row gutter={[20, 20]}>
                        {activeOrders?.map((item, index) => {
                          return (
                            item.status !== "done" && (
                              <Col
                                key={item.billId}
                                className={classes.customCol6}
                                span={6}
                              >
                                <KitchenCard
                                  item={item}
                                  id={index}
                                  setOrders={setOrders}
                                />
                              </Col>
                            )
                          );
                        })}
                      </Row>
                    ) : (
                      <div
                        style={{
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          height: "calc(100vh - 100px)",
                        }}
                      >
                        <h5>No orders</h5>
                      </div>
                    )}
                  </>
                ) : (
                  <Alert
                    style={{ marginTop: "20px", padding: "20px" }}
                    message="You don't have access, Please contact your administrator to request the appropriate access."
                    type="error"
                  />
                )}
              </>
            )}
            {tabKey === "2" && (
              <>
                {access.completedOrder(false) ? (
                  <Completed orders={orders} />
                ) : (
                  <Alert
                    style={{ marginTop: "20px", padding: "20px" }}
                    message="You don't have access, Please contact your administrator to request the appropriate access."
                    type="error"
                  />
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default KitchenOrderView;
